/*
 *
 * NavigationBar Constants
 *
 */

export const PERFORMER_FILTER_CHANGE = 'src/NavBar/SelectedPerformer/PERFORMER_FILTER_CHANGE';
export const RESET_PERFORMER_FILTER = 'src/NavBar/SelectedPerformer/RESET_PERFORMER_FILTER';
